import { Component } from '@angular/core';
import { SignUpStoreService } from '../../../services/sign-up-store/sign-up-store.service';
import { MesInformationsFormComponent } from './mes-informations-form/mes-informations-form.component';
import { SignUpInformationsData } from '../interfaces/sign-up-store.interface';
import { StepperNavigationHelperService } from '../../../../shared/services/behavior/stepper-navigation-helper.service';
import { LoginService } from '../../../services/login/login.service';

@Component({
  selector: 'app-mes-informations',
  standalone: true,
  imports: [MesInformationsFormComponent],
  templateUrl: './mes-informations.component.html',
  styleUrl: './mes-informations.component.scss',
})
export class MesInformationsComponent {
  constructor(
    private readonly signUpStoreService: SignUpStoreService,
    private readonly stepperNavigationHelperService: StepperNavigationHelperService,
    private readonly loginService: LoginService,
  ) {}

  informations: SignUpInformationsData =
    this.signUpStoreService.getInformationsSnapshot();
  loginAlreadyExists = false;

  public onInformationsChanged(informations: SignUpInformationsData): void {
    this.informations = informations;
    this.signUpStoreService.patchInformations(informations);
  }

  public onDisableNextButton(disable: boolean) {
    this.stepperNavigationHelperService.emitDisableGoToStep(disable);
  }

  public async onVerifyLogin(login: string): Promise<void> {
    this.loginAlreadyExists = await this.loginService.isLoginTaken(login);
  }

  public onCleanLoginError(): void {
    this.loginAlreadyExists = false;
  }
}
